import { format, parseISO } from 'date-fns';
import { sl } from 'date-fns/locale';

// Format date for display in Slovene
export const formatDate = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, 'd. MMMM yyyy', { locale: sl });
  } catch (error) {
    return dateString;
  }
};

// Format date for input fields (YYYY-MM-DD)
export const formatDateForInput = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    return format(date, 'yyyy-MM-dd');
  } catch (error) {
    return dateString;
  }
};

// Get today's date in YYYY-MM-DD format
export const getTodayString = (): string => {
  return format(new Date(), 'yyyy-MM-dd');
};
